// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2oecp","requiredAsterisk":"Info_requiredAsterisk__3frAb"};